import { Pipe, PipeTransform } from '@angular/core';
import { buildPlaybookActionTypeDisplayName } from '../../labels/utils';
import { ActionTypes } from '../../models/api/playbooks/actions/actionTypes.enum';

@Pipe({
  name: 'playbookActionTypeDisplayName',
})
export class PlaybookActionTypeDisplayName implements PipeTransform {
  /**
   * A pipe to convert a playbook action type enum into its display value.
   */

  public transform(playbookActionType: ActionTypes): string {
    return buildPlaybookActionTypeDisplayName(playbookActionType);
  }
}
